import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import { Body3 } from '../../text/Text';
import style from './BoxInput.module.css';

export const BoxInput = ({
  width,
  height,
  fontSize,
  backgroundColor,
  value,
  setValue,
  symbol,
  direction,
  disabled
}) => {
  return (
    <div
      className={style.box}
      style={{ width, height, fontSize, backgroundColor, borderColor: disabled ? 'grey' : colors.lightGrey }}
    >
      {direction === 'left' ? (
        <Body3 fontWeight={700} color={disabled ? 'grey' : colors.lightGrey}>
          {symbol}
        </Body3>
      ) : null}
      <input
        disabled={disabled}
        style={{ fontSize }}
        className={style.input}
        value={value}
        onChange={({ target }) => setValue(target.value)}
      />
      {direction === 'right' ? (
        <Body3 fontWeight={700} color={disabled ? 'grey' : colors.lightGrey}>
          {symbol}
        </Body3>
      ) : null}
    </div>
  );
};

BoxInput.propTypes = {
  backgroundColor: PropTypes.string,
  direction: PropTypes.string,
  fontSize: PropTypes.string,
  height: PropTypes.string,
  setValue: PropTypes.func,
  symbol: PropTypes.string,
  value: PropTypes.any,
  width: PropTypes.string,
  disabled: PropTypes.any
};
